import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toObservable, toSignal } from "@angular/core/rxjs-interop";

import { HttpActivityService } from "@core/services/http-activity.service";
import { TranslatePipe } from "@ngx-translate/core";
import { distinctUntilChanged, map, of, switchMap, timer } from "rxjs";

/** A request quicker than this shows no bar - it would only flicker. */
const SHOW_AFTER_MS = 200;

/**
 * A thin bar along the top of the window while anything is loading or
 * saving. Above dialogs too, so the wait between clicking "edit" and a dialog
 * that fetches first no longer looks like a click that did nothing.
 */
@Component({
  selector: "app-http-progress",
  template: `
    @if (visible()) {
      <div
        class="http-progress"
        role="progressbar"
        [attr.aria-label]="'SHELL_LOADING' | translate"
      >
        <span class="http-progress__bar"></span>
      </div>
    }
  `,
  styleUrls: ["./http-progress.component.scss"],
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HttpProgressComponent {
  private readonly activity = inject(HttpActivityService);

  protected readonly visible = toSignal(
    toObservable(this.activity.busy).pipe(
      distinctUntilChanged(),
      switchMap((busy: boolean) =>
        busy ? timer(SHOW_AFTER_MS).pipe(map((): boolean => true)) : of(false)
      )
    ),
    { initialValue: false }
  );
}
